import { Route, Routes } from 'react-router-dom';

import BrowserExtension from '../../../helpAndKnowledgePage/components/browserExtension/BrowserExtension';
import Candidates from '../../../helpAndKnowledgePage/components/candidates/Candidates';
import DataPrivacy from '../../../helpAndKnowledgePage/components/dataPrivacy/DataPrivacy';
import Jobs from '../../../helpAndKnowledgePage/components/jobs/Jobs';
import PaymentIntegration from '../../../helpAndKnowledgePage/components/paymentIntegration/PaymentIntegration';
import TeamOwners from '../../../helpAndKnowledgePage/components/teamOwners/TeamOwners';
import { CandidateCommunication } from '../helpVideos/components/candidateCommunication';
import CandidatesSourcing from '../helpVideos/components/candidatesSourcing/CandidatesSourcing';
import { GettingSetup } from '../helpVideos/components/gettingSetup';
import JobsDescription from '../helpVideos/components/jobDescription/JobDescription';
import { WorkspaceAdmin } from '../helpVideos/components/workspaceAdmin';

export const FAQsRoutes = () => (
  <Routes>
    <Route path="/jobs" element={<Jobs isFromSettings={true} />} />
    <Route path="/candidates" element={<Candidates isFromSettings={true} />} />
    <Route path="/data-privacy" element={<DataPrivacy isFromSettings={true} />} />
    <Route path="/browser-extension" element={<BrowserExtension isFromSettings={true} />} />
    <Route path="/team-owners" element={<TeamOwners isFromSettings={true} />} />
    <Route path="/payment-integration" element={<PaymentIntegration isFromSettings={true} />} />
    <Route path="/job-videos" element={<JobsDescription />} />
    <Route path="/candidates-sourcing" element={<CandidatesSourcing />} />
    <Route path="/candidate-communication" element={<CandidateCommunication />} />
    <Route path="/getting-setup" element={<GettingSetup />} />
    <Route path="/workspace-admin" element={<WorkspaceAdmin />} />
  </Routes>
);
